import type { ReactNode } from "react";
import { AlertCircle, CheckCircle2, Info, TriangleAlert } from "lucide-react";

type Tone = "info" | "success" | "warning" | "danger";
const icons = { info: Info, success: CheckCircle2, warning: TriangleAlert, danger: AlertCircle };

export function StatusNotice({ tone = "info", title, children, action }: { tone?: Tone; title: string; children?: ReactNode; action?: ReactNode }) {
  const Icon = icons[tone];
  return (
    <div className={`notice notice--${tone}`} role={tone === "danger" ? "alert" : "status"}>
      <Icon aria-hidden="true" size={19} />
      <div><strong>{title}</strong>{children ? <span>{children}</span> : null}</div>
      {action ? <div className="notice__action">{action}</div> : null}
    </div>
  );
}
